import { Flex, Text } from '@mantine/core';
import { ReactNode } from 'react';

import classes from './Text.module.css';

interface TitleCardProps {
  title: string;
  pre?: ReactNode;
}

export function TitleCard({ title, pre }: TitleCardProps) {
  return (
    <Flex
      align="center"
      gap="10px"
      className={classes.titleCardContainer}
      p="sm"
    >
      {pre}
      <Text fw="500">{title}</Text>
    </Flex>
  );
}
